import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { isNullOrEmptyString } from '../../../../shared/utils.js';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { eFeatures } from '../../../models/enum.model';
import { PlayAudioResponse } from '../../../models/voiceCall.model.js';
import { GlobalService } from '../../../services/global.service';
import { NotificationService } from '../../../services/notification.service';
import { LocalService } from '../../../services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../services/shared/utility.service';
import { VoiceCallService } from '../../../services/voice-call.service';

@Component({
    selector: 'app-playaudio',
    templateUrl: './playaudio.component.html',
    styleUrls: ['./playaudio.component.css']
})
export class PlayaudioComponent {
    private encryptedUser: string = '';
    showSpinner: boolean = false;
    userResponse: UserResponse;
    user: CLPUser;
    dateFormat: string = "MM/dd/yyyy";
    dateFormatWithTime: string = "";
    routeParamsSubscription: Subscription;
    litOutPut: string = "Unrecognized format";
    litLog: string = "";
    id: number = 0;
    tpe: string = "";
    adm: number = 0;
    isFromRec: boolean = true;
    isShowJSONTxt: boolean = false;
    playAudioResponse: PlayAudioResponse;
    aiSummaryDisplay: string = "";
    txtAIOutput: string = "";
    pnlAIOutput: boolean;
    litTranscript: string = ""
    btnisShowSum: boolean = false;
    voiceCallRecordingId: number = 0;
    private destroy$ = new Subject<void>();

    constructor(private _utilityService: UtilityService,
        private _notifyService: NotificationService,
        private _router: Router,
        private route: ActivatedRoute,
        public _localService: LocalService,
        private _globalService: GlobalService,
        private _voiceCallService: VoiceCallService) {

    }

    ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.dateFormat = this.user.dateFormat;
                        this.dateFormatWithTime = this.user.dateFormat + ' ' + ' h:mm a';
                        this.routeParamsSubscription = this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
                            if (!isNullOrUndefined(params)) {
                                if (params?.id > 0) {
                                    this.id = +params?.id;
                                }
                                if (!isNullOrEmptyString(params?.tpe)) {
                                    this.tpe = params?.tpe;
                                }
                                if (params?.adm > 0) {
                                    this.adm = +params?.adm;
                                }
                                if (params?.isjim == "yep") {
                                    this.isShowJSONTxt = true;
                                }
                            }
                        })
                        if (this.id > 0 && !isNullOrEmptyString(this.tpe)) {
                            this.initloadData();
                        }
                    }
                    else
                        this._router.navigate(['/login']);
                })
            }
            else
                this._router.navigate(['/login']);
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    async initloadData() {
        await this._voiceCallService.playAudio(this.encryptedUser, this.tpe, this.id)
            .then(async (result: PlayAudioResponse) => {
                if (result) {
                    this.playAudioResponse = UtilityService.clone(result);
                    this.litOutPut = this.playAudioResponse.litOutPut;
                    this.aiSummaryDisplay = this.playAudioResponse.aiSummaryDisplay;
                    this.txtAIOutput = this.playAudioResponse.txtAIOutput;
                    this.pnlAIOutput = this.playAudioResponse.pnlAIOutput;
                    this.litTranscript = this.playAudioResponse.litTranscript;
                    this.btnisShowSum = this.playAudioResponse.isShowbtnSummarize;
                    this.voiceCallRecordingId = this.playAudioResponse.voiceCallRecordingId;

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("playaudio.playAudio", err.message, null,
                    'id: ' + this.id + 'type ' + this.tpe
                );
                this._utilityService.handleErrorResponse(err);
            });
    }



    private async authenticateR() {
        this.showSpinner = true;
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.userResponse)) {
                        if (!isNullOrUndefined(this.userResponse?.user)) {
                            this.user = this.userResponse.user;
                            this._localService.isMenu = false;
                            this._localService.isFooter = false;
                        }
                        else {
                            this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("playaudio.authenticateR", err.message, null);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });

    }


    async summarizeWithAI() {
        await this._voiceCallService.genrateAISummarize(this.encryptedUser, this.voiceCallRecordingId)
            .then(async (result: PlayAudioResponse) => {
                if (result) {
                    console.log(result);
                    let response = UtilityService.clone(result);
                    this.pnlAIOutput = false;
                    if (this.btnisShowSum == true) {
                        this.aiSummaryDisplay = response.aiSummaryDisplay;
                        this.txtAIOutput = response.txtAIOutput;
                        this.pnlAIOutput = response.pnlAIOutput;
                        this.pnlAIOutput = true;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-activity-history.getVoiceCallLoad", err.message, null,
                    'id: ' + this.id
                );
                this._utilityService.handleErrorResponse(err);
            });
    }
}
